// extracted by mini-css-extract-plugin
module.exports = {"input-number":"Deposit_input-number__3c5Hc","payment-type":"Deposit_payment-type__2cD3R","no-bank-account":"Deposit_no-bank-account__1fLei","aan-alert":"Deposit_aan-alert__1dx3y"};